import React, { useState } from "react";

import Photo from "./items/Photo";
import SlideMenu from "./SlideMenu";

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="darkdivColor">
      {isOpen ? <SlideMenu setIsOpen={setIsOpen} /> : null}
      <div className="navbar container">
        <div className="toggle-menu" onClick={() => setIsOpen(true)}>
          <span></span>
          <span></span>
        </div>
        <h5 className="darktextColor textBrandNavbar">flipcard</h5>
        <div className="box-pic">
          <Photo />
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
